import React from "react";
import { trackEvent } from "../analytics";

const badges = [
  { label: "30 min", detail: "Discovery call" },
  { label: "No pitch", detail: "Just honest, senior advice" },
  { label: "Direct access", detail: "No account managers in between" },
];

export default function ClarityCall() {
  return (
    <section className="bg-purple-900 text-white relative overflow-hidden">
      <div
        className="absolute -top-24 right-1/4 w-80 h-80 rounded-full bg-fuchsia-600 opacity-20 blur-3xl pointer-events-none"
        aria-hidden="true"
      />
      <div className="container px-5 py-16 mx-auto flex flex-col items-center text-center relative">
        <h1 className="text-4xl sm:text-5xl font-bold title-font mb-4">
          Talk to an Expert
        </h1>
        <p className="leading-relaxed text-base sm:text-lg lg:w-2/3 mb-8 text-purple-200">
          A free 30-minute call about your software problem. We'll diagnose
          what's really going on and map the fastest, safest path forward.
        </p>
        <a
          href="#contact"
          onClick={() => trackEvent("cta_click", { location: "clarity_call" })}
          className="inline-flex text-purple-900 bg-white border-0 py-3 px-8 focus:outline-none hover:bg-purple-100 rounded-full text-lg mb-10 font-medium"
        >
          Book a Call
        </a>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 w-full lg:w-2/3">
          {badges.map((badge) => (
            <div
              key={badge.label}
              className="bg-purple-800 border border-purple-700 rounded-xl p-5"
            >
              <p className="text-white font-semibold title-font">
                {badge.label}
              </p>
              <p className="text-purple-200 text-sm mt-1">{badge.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
